const React = require('react')
const { useState } = require('react')
const { useLocation } = require('react-router-dom')
const { Row, Col, Card, CardHeader, CardBody, Collapse, FormGroup, Label, Input, Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const UploadContract = props => {
    const { files, setFiles } = props
    const { network } = useNetworkConfig()
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const contractAddress = params.get('a')
    const compilerVersion = params.get('c')

    const [errors, setErrors] = useState({})
    const [isSourceCodeOpen, setIsSourceCodeOpen] = useState(true)

    const handleFileChange = e => {
        const selectedFiles = Array.from(e.target.files)
        const invalidFiles = selectedFiles.filter(file => !file.name.endsWith('.sol'))

        if (invalidFiles.length > 0) {
            setErrors(prev => ({
                ...prev,
                files: 'Only .sol files are allowed'
            }))
            return
        }

        setFiles(selectedFiles)
        setErrors(prev => ({
            ...prev,
            files: ''
        }))
    }

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsSourceCodeOpen(!isSourceCodeOpen)}
                style={{
                    border: !isSourceCodeOpen && 'none',
                    borderColor: isSourceCodeOpen && 'var(--dropdown-background)'
                }}
            >
                <span style={{ fontWeight: 'bold' }}>Upload Contract Source Code</span>
                <i className={`fas fa-angle-${isSourceCodeOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isSourceCodeOpen}>
                <CardBody>
                    <div style={{ marginBottom: '8px' }}>
                        1. If the contract compiles correctly at&nbsp;
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() => window.open('https://remix.ethereum.org/', '_blank')}
                        >
                            REMIX
                        </span>
                        , it should also compile correctly here.
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        2. As this is an beta release module, there is limited support for external libraries.
                    </div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0'
                        }}
                    >
                        <Row style={{ marginBottom: '8px' }}>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Contract Address:
                            </Col>
                            <Col
                                xs='9'
                                className={`${network.name}-text-color cursor-pointer`}
                                style={{ fontWeight: 'bold' }}
                                onClick={() => {
                                    const url = `/${network.name}/address/${contractAddress}`
                                    window.open(window.location.origin + url, '_blank')
                                }}
                            >
                                {contractAddress}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '8px' }}>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Compiler Type:
                            </Col>
                            <Col xs='9' style={{ fontWeight: 'bold' }}>
                                SOLIDITY MULTI-PART VERIFIER (IMPORTS)
                            </Col>
                        </Row>
                        <Row>
                            <Col xs='3' style={{ color: 'var(--grey-color)' }}>
                                Compiler Version:
                            </Col>
                            <Col xs='9' style={{ fontWeight: 'bold' }}>
                                {compilerVersion}
                            </Col>
                        </Row>
                    </div>
                    <FormGroup>
                        <Label style={{ fontWeight: 'bold' }}>
                            Please select the Solidity (*.sol) files for upload
                        </Label>
                        <div
                            style={{
                                borderRadius: '8px',
                                padding: '16px',
                                height: '250px',
                                border: '2px dashed var(--dropdown-background)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <i
                                className='fas fa-file-code'
                                style={{
                                    fontSize: '36px',
                                    color: 'var(--white-color)'
                                }}
                            />
                            <div style={{ marginTop: '8px' }}>CTRL click to select Multiple files</div>
                            <div style={{ marginTop: '4px', fontSize: '12px', color: 'var(--grey-color)' }}>
                                Supported file types: .sol
                            </div>
                            <div style={{ marginTop: '16px', position: 'relative' }}>
                                <Input
                                    type='file'
                                    multiple
                                    accept='.sol'
                                    onChange={handleFileChange}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        width: '100%',
                                        height: '100%',
                                        cursor: 'pointer',
                                        zIndex: 2
                                    }}
                                />
                                <Button
                                    className={`${network.name}-btn`}
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: 'normal',
                                        position: 'relative',
                                        zIndex: 1,
                                        background: `var(--${network.name}-color) !important`,
                                        border: 'none'
                                    }}
                                >
                                    Upload File
                                </Button>
                            </div>
                            {files.length > 0 && (
                                <div style={{ marginTop: '8px', fontSize: '12px' }}>
                                    {files.length} file{files.length > 1 ? 's' : ''} selected
                                </div>
                            )}
                            {errors.files && (
                                <div style={{ marginTop: '8px', color: 'var(--red-color)', fontSize: '12px' }}>
                                    {errors.files}
                                </div>
                            )}
                        </div>
                        {files.length > 0 && (
                            <div style={{ marginTop: '16px' }}>
                                Your {files.length} file{files.length > 1 ? 's' : ''} was uploaded successfully :
                                <div
                                    style={{
                                        backgroundColor: 'var(--dropdown-background)',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        marginTop: '8px'
                                    }}
                                >
                                    {files.map((file, index) => (
                                        <div key={index} style={{ marginBottom: '8px' }}>
                                            {index + 1}/ {file.name} ({file.size} bytes)
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </FormGroup>
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { UploadContract }
